/**
 * submitSuggestion — 提交建议工具
 *
 * 用户提出建议时，调用 /suggestion/create 接口提交，
 * 返回蒂亚风格的确认回复。
 */

import { suggestionAPI } from '@/service/suggestion';

/**
 * 提交建议
 * @param content 建议内容
 * @returns 蒂亚风格的确认回复
 */
export async function submitSuggestion(content: string): Promise<string> {
  try {
    await suggestionAPI.create({ content });
    return '已收到你的建议啦～我会认真转达给阿呆的，谢谢你的心意呀！(｡･ω･｡)ﾉ♡';
  } catch {
    return '呜…提交建议的时候出了点小问题，要不你待会再试试？抱歉呀～';
  }
}
